// extracted by mini-css-extract-plugin
export default {"Cart":"Cart_Cart__EQTr2"};